import { render, staticRenderFns } from "./zhaocheshuoming.vue?vue&type=template&id=da9890b2&scoped=true&"
import script from "./zhaocheshuoming.vue?vue&type=script&lang=js&"
export * from "./zhaocheshuoming.vue?vue&type=script&lang=js&"
import style0 from "./zhaocheshuoming.vue?vue&type=style&index=0&id=da9890b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9890b2",
  null
  
)

export default component.exports